export const AREA_PAGE_FOURTH_MAP_CARD_FLAG = 'area-page-fourth-map-card';
